/* Pawganix ADA 020 (WCAG 2.4.4 Link Purpose): adds hidden context to links whose only visible
   words are "Shop Now", so a screen reader announces "Shop Now: CalmGuard Cat Calming ...".
   Visible text is never changed, so the accessible name still starts with the visible words
   (WCAG 2.5.3). A link can set its own context with data-pgx-context="...". Links the page
   builds or rewrites after load are picked up again automatically. */
(function () {
  'use strict';
  if (window.pgxLinkCtxInit) return;
  window.pgxLinkCtxInit = true;

  var K = 'pgx-ctx';
  var SITE = /\s*[\u2013\u2014|-]\s*Pawganix\s*$/i;
  var cache = {}, waiting = {}, timer = null, pageName = null;

  function clean(t) {
    return String(t || '').replace(/\s+/g, ' ').replace(SITE, '').replace(/^Pawganix\s+/i, '').trim();
  }
  function short(t) {
    return t.length > 70 ? t.slice(0, 70).replace(/\s+\S*$/, '') : t;
  }
  function visibleText(a) {
    var s = '';
    for (var n = a.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n.classList.contains(K)) continue;
      s += n.textContent;
    }
    return s;
  }
  function isShopNow(a) {
    return visibleText(a).replace(/[^a-z]/gi, '').toLowerCase() === 'shopnow';
  }
  function pageHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function pageContext() {
    if (pageName !== null) return pageName;
    var name = '';
    var s = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < s.length && !name; i++) {
      try {
        var d = JSON.parse(s[i].textContent), q = [].concat(d['@graph'] || d);
        for (var j = 0; j < q.length; j++) {
          var t = [].concat((q[j] && q[j]['@type']) || []);
          if (q[j] && q[j].name && t.indexOf('Product') > -1) { name = clean(q[j].name); break; }
        }
      } catch (e) {}
    }
    if (!name) {
      var og = document.querySelector('meta[property="og:title"]');
      name = clean((og && og.content) || document.title);
    }
    pageName = short(name);
    return pageName;
  }
  function lookup(handle, cb) {
    if (handle in cache) { cb(cache[handle]); return; }
    if (waiting[handle]) { waiting[handle].push(cb); return; }
    waiting[handle] = [cb];
    function finish(v) {
      cache[handle] = v;
      var q = waiting[handle];
      delete waiting[handle];
      for (var i = 0; i < q.length; i++) q[i](v);
    }
    try {
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { finish(d && d.title ? short(clean(d.title)) : null); })
        .catch(function () { finish(null); });
    } catch (e) { finish(null); }
  }
  function contextFor(a, done) {
    var own = a.getAttribute('data-pgx-context');
    if (own) { done(own); return; }
    var href = a.getAttribute('href') || '';
    var p = href.match(/\/products\/([^/?#]+)/);
    if (p && decodeURIComponent(p[1]) !== pageHandle()) {
      lookup(decodeURIComponent(p[1]), function (n) { done(n || pageContext()); });
      return;
    }
    var c = href.match(/\/collections\/([^/?#]+)/);
    if (c) {
      var h = decodeURIComponent(c[1]);
      done(h === 'all' ? 'all products' : h.replace(/-/g, ' '));
      return;
    }
    done(pageContext());
  }
  function apply(a, text) {
    if (!a.isConnected || !isShopNow(a) || a.querySelector('.' + K)) return;
    var label = a.getAttribute('aria-label');
    if (label) {
      if (!a.hasAttribute('data-pgx-ctx')) {
        a.setAttribute('aria-label', label + ': ' + text);
        a.setAttribute('data-pgx-ctx', '1');
      }
      return;
    }
    var sp = document.createElement('span');
    sp.className = 'visually-hidden ' + K;
    sp.textContent = ': ' + text;
    a.appendChild(sp);
  }
  function add(a) {
    contextFor(a, function (text) { apply(a, text); });
  }
  function scan() {
    timer = null;
    try {
      var links = document.querySelectorAll('a');
      for (var i = 0; i < links.length; i++) {
        var a = links[i], sp = a.querySelector('.' + K), yes = isShopNow(a);
        if (sp) { if (!yes) sp.parentNode.removeChild(sp); continue; }
        if (!yes || a.hasAttribute('data-pgx-ctx')) continue;
        add(a);
      }
    } catch (e) {}
  }
  function queue() {
    if (timer) return;
    timer = setTimeout(scan, 250);
  }

  /* Re-run when the page changes, but ignore changes this script makes itself. */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'characterData') { queue(); return; }
      var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (!(n.nodeType === 1 && n.classList.contains(K))) { queue(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  queue();
  window.addEventListener('load', queue);
  document.addEventListener('DOMContentLoaded', queue);
})();
;(function(){
  function fix(){
    var f=document.getElementById('merchantwidgetiframe');
    if(!f) return false;
    if(!f.getAttribute('title')) f.setAttribute('title','Google store reviews badge');
    return true;
  }
  if(fix()) return;
  var mo=new MutationObserver(function(){ if(fix()) mo.disconnect(); });
  mo.observe(document.documentElement,{childList:true,subtree:true});
  setTimeout(function(){ mo.disconnect(); },30000);
})();
;(function(){
  var mq=window.matchMedia('(max-width: 576px)');
  var uid=0;
  function enable(box,h){
    if(h.querySelector('.pgx-foot-btn')) return;
    var b=document.createElement('button');
    b.type='button';
    b.className='pgx-foot-btn';
    while(h.firstChild){ b.appendChild(h.firstChild); }
    h.appendChild(b);
    var panel=box.nextElementSibling;
    if(panel){
      if(!panel.id){ panel.id='pgx-foot-panel-'+(++uid); }
      b.setAttribute('aria-controls',panel.id);
    }
    b.setAttribute('aria-expanded',box.hasAttribute('open')?'true':'false');
    b.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      box.click();
    });
    if(!box.__pgxObs){
      box.__pgxObs=new MutationObserver(function(){
        var cur=h.querySelector('.pgx-foot-btn');
        if(cur){ cur.setAttribute('aria-expanded',box.hasAttribute('open')?'true':'false'); }
      });
      box.__pgxObs.observe(box,{attributes:true,attributeFilter:['open']});
    }
  }
  function disable(h){
    var b=h.querySelector('.pgx-foot-btn');
    if(!b) return;
    while(b.firstChild){ h.insertBefore(b.firstChild,b); }
    h.removeChild(b);
  }
  function sync(){
    document.querySelectorAll('footer-accordion .footer__accordion__heading').forEach(function(box){
      var h=box.querySelector('h2,h3,h4,h5,h6');
      if(!h) return;
      if(mq.matches){ enable(box,h); } else { disable(h); }
    });
  }
  function start(){
    sync();
    if(mq.addEventListener){ mq.addEventListener('change',sync); }
    else if(mq.addListener){ mq.addListener(sync); }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',start); }
  else { start(); }
})();